import AppError from "./AppError";

export default AppError;
